import { Sound } from "./sound";
import { Octave, Pitch, Step } from "./music";


export class Assets {

	/**
	 * Piano has base pitches D1..7 and A1..7
	 */
	private static getPianoBasePitches = function(): Pitch[] {
		let basePitches: Pitch[] = [];
		for (let octave = 1; octave <= 7; octave++)
			for (let step of ["D", "A"])
				basePitches.push(new Pitch(step as Step, 0, octave as Octave))
		return basePitches
	}

	static basePitches = {
		"AltoSax": [new Pitch("B", -1, 4)],
		"BassClarinet": [new Pitch("B", -1, 3)],
		"Bassoon": [new Pitch("B", -1, 3)],
		"Clarinet": [new Pitch("B", -1, 4)],
		"EbClarinet": [new Pitch("B", -1, 5)],
		"Flute": [new Pitch("B", -1, 5)],
		"Horn": [new Pitch("B", -1, 3)],
		"Oboe": [new Pitch("B", -1, 4)],
		"Piano": Assets.getPianoBasePitches(),
		"Trombone": [new Pitch("B", -1, 3)],
		"Trumpet": [new Pitch("B", -1, 4)],
		"Tuba": [new Pitch("B", -1, 2)],
		"TuningFork": [new Pitch("B", -1, 4), new Pitch("F", 0, 5), new Pitch("B", -1, 5)]
	}

}


// WEBPACK FOOTER //
// ./src/model/assets.ts